import React from 'react'

import { IconProps, iconClassName, iconColor } from './IconProps'

export const ProfileIcon: React.FC<IconProps> = (props) => {
  const { size = 24, width, height, onClick, strokeWidth = 2, ...rest } = props

  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={iconClassName(props)}
      onClick={onClick}
      {...rest}
    >
      <path
        d='M20 21C20 18.2386 16.4183 16 12 16C7.58172 16 4 18.2386 4 21M12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13Z'
        stroke={iconColor(props)}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
